'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1 from "./scala.scalajs.runtime.-Anon-Function1.$$-Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction2$002e$0024$0024$002dLambda$0024770e9b86e03b055b1d78d82135c9f39ea48d32d7 from "./scala.scalajs.runtime.-Anon-Function2.$$-Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7.js";
var $p;
/** @constructor */
function $c_Ljava_text_ParsePosition(index) {
  this.gR = 0;
  this.gQ = 0;
  this.gR = index;
  this.gQ = (-1);
}
export { $c_Ljava_text_ParsePosition as $c_Ljava_text_ParsePosition };
$p = $c_Ljava_text_ParsePosition.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_text_ParsePosition;
/** @constructor */
function $h_Ljava_text_ParsePosition() {
}
export { $h_Ljava_text_ParsePosition as $h_Ljava_text_ParsePosition };
$h_Ljava_text_ParsePosition.prototype = $p;
$p.f = (function(other) {
  return ((other instanceof $c_Ljava_text_ParsePosition) && ((this.gQ === other.gQ) && (this.gR === other.gR)));
});
$p.m = (function() {
  return ($j_java$002elang$002e$002dObject.$m_sci_Seq$().x0($j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().R2(new $j_java$002elang$002e$002dObject.$ac_I(new Int32Array([this.gQ, this.gR])))).a7(new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((_$1) => (_$1 | 0)))).ih(0, new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction2$002e$0024$0024$002dLambda$0024770e9b86e03b055b1d78d82135c9f39ea48d32d7.$c_sjsr_AnonFunction2_$$Lambda$770e9b86e03b055b1d78d82135c9f39ea48d32d7(((a, b) => ((Math.imul(31, (a | 0)) + (b | 0)) | 0)))) | 0);
});
$p.b = (function() {
  return (((("java.text.ParsePosition[index=" + this.gR) + ",errorIndex=") + this.gQ) + "]");
});
function $isArrayOf_Ljava_text_ParsePosition(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dv)));
}
export { $isArrayOf_Ljava_text_ParsePosition as $isArrayOf_Ljava_text_ParsePosition };
var $d_Ljava_text_ParsePosition = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_text_ParsePosition, "java.text.ParsePosition", ({
  dv: 1
}));
export { $d_Ljava_text_ParsePosition as $d_Ljava_text_ParsePosition };
